import { render, staticRenderFns } from "./VendaCliente.vue?vue&type=template&id=1d0665aa&"
import script from "./VendaCliente.vue?vue&type=script&lang=js&"
export * from "./VendaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports